var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"u-w-full"},[_c(_setup.itemComponentName,{tag:"Component",attrs:{"item":_vm.item,"is-current-page":_vm.isCurrentPage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }